import { FormattedMessage as FM } from "react-intl";

function Contract({ handleChangeCheckContract, checked, configHotel }) {
  return (
    <div>
      <p className="max-h-96 overflow-y-auto pr-3 bg-gray-100 p-4 rounded-2xl">
        {configHotel.value?.registration_card_contract ||
          "No hay ningún contrato configurado"}
      </p>
      <div className="col-span-3 space-y-3 mt-5">
        <label className="flex md:items-start space-x-4 text-gray-800 text-sm cursor-pointer select-none ">
          <input
            type="checkbox"
            checked={checked.value}
            onChange={handleChangeCheckContract}
            className="
         accent-green-400 size-15 cursor-pointer tablet:size-10 tablet:-top-0.5 md:size-6
         transition-all duration-200  focus:outline-none
         rounded-full
         relative top-1
       "
          />
          <p className="text-neutral-800 text-md ">
            <b>
              <FM id="hotel.folio.guest.terms_and_conditions1" />
            </b>
            <FM id="hotel.folio.guest.terms_and_conditions2" />
          </p>
        </label>
      </div>
    </div>
  );
}

export default Contract;
